import { faClose } from '@fortawesome/pro-regular-svg-icons'
import { FullScreenModal } from 'V2Components'
import { getHTMLDataTestID } from 'infra/utils'
import { Button, Typography } from 'procyon-ui'
import React from 'react'

function ErrorModal({
  showModal,
  message,
  onClose,
  onViewDetailsClick = null,
  title,
  hideViewDetails = false
}) {
  return (
    <FullScreenModal showModal={showModal}>
      <div className='flex justify-center items-center h-[100%] bg-[var(--color-common-bg-base)]'>
        <div
          data-testid={getHTMLDataTestID('error-modal', 'div', 'wrapper')}
          className='w-[626px] rounded-lg p-8 bg-white'
        >
          <div className='flex justify-between'>
            <Typography
              style={{color:'var(--color-font-base)'}}
              data-testid={getHTMLDataTestID('error-modal', 'p', 'title')}
              variant='title-regular'
              className='!text-lg'
            >
              {title}
            </Typography>
            <div className='flex gap-4'>
              {!hideViewDetails && (
                <Button
                  data-testid={getHTMLDataTestID('error-modal', 'button', 'view-details')}
                  onClick={onViewDetailsClick}
                  variant='grayBlue'
                >
                  View Details
                </Button>
              )}
              <Button
                data-testid={getHTMLDataTestID('error-modal', 'button', 'close')}
                onClick={onClose}
                variant='gray'
                icon={faClose}
                iconPosition='end'
              >
                Close
              </Button>
            </div>
          </div>
          <div className='bg-red-500 p-4 mt-8 rounded text-white max-h-[60vh] overflow-auto'>
            <code data-testid={getHTMLDataTestID('error-modal', 'code', 'message')}>
              {typeof message === 'object' ? JSON.stringify(message) : message}
            </code>
          </div>
        </div>
      </div>
    </FullScreenModal>
  )
}

export { ErrorModal }
